import React from 'react';
import Table, { Cell, HeaderRow, Row } from '../../components/table/Table';
import Inline, { inlineAlignment } from '../../components/layout/Inline';
import Button from '../../components/form/Button';
import { joinDefined, PAGE_CREMATIONS, PAGE_ENQUIRIES } from '../../utils/strings';
import { shortDateTimeFromString } from '../../utils/date';
import { AshesCollectedByOptions } from '../../components/ComponentConstants';
import { DriverDeliveryIcon } from '../../components/IconIndex';

export default function DeliveryRunsheet({ delivery, countA }) {
    const spacer = '(not set)';
    const deceased = !!delivery && !!delivery.CremationOrder && delivery.CremationOrder.ID > 0
        ? delivery.CremationOrder.Deceased
        : delivery.Enquiry.Deceased;
    const deceasedName =
        (!!deceased && joinDefined([deceased.FirstName, deceased.MiddleName, deceased.Surname], ' ')) || spacer;

    const deliveryDateTime = shortDateTimeFromString(joinDefined([delivery.Date || '', delivery.Time || ''], ' '));
    const addr = delivery.DestinationAddress;
    const addrString =
        joinDefined(
            [addr.Line1 || addr.AddressLine1, addr.Line2 || addr.AddressLine2, addr.Suburb, addr.State],
            ', '
        ) || spacer;
    const comment = delivery.comment || '(none)';
    const containment = delivery.ContainmentStyle || spacer;
    const staff =
        delivery.AssignedStaff && delivery.AssignedStaff.length > 0
            ? delivery.AssignedStaff.map(member => joinDefined([member.FirstName, member.Surname], ' ')).join(', ')
            : spacer;
    const ashesCollectedByOption = AshesCollectedByOptions.find(option => option.value === delivery.AshesCollectedBy);
    const ashesCollectedBy = ashesCollectedByOption ? ashesCollectedByOption.label : spacer;
    const isCremationOrder = !!delivery && delivery.CremationOrderID > 0;
    const isEnquiryByBusiness = !!delivery.Enquiry.ClientSameAsEnquirer;
    const isEnquirerWasBusiness = !!delivery.CremationOrder.EnquirerWasBusiness;
    const name = !isCremationOrder
        ? isEnquiryByBusiness
            ? delivery.Enquiry.Business.Name
            : joinDefined([delivery.Enquiry.Client.FirstName, delivery.Enquiry.Client.Surname], ' ')
        : isEnquirerWasBusiness
            ? delivery.CremationOrder.Business.Name
            : joinDefined([delivery.CremationOrder.Client.FirstName, delivery.CremationOrder.Client.Surname], ' ');

    const phone = (!isCremationOrder
        ? isEnquiryByBusiness
            ? delivery.Enquiry.Business.Phone
            : delivery.Enquiry.Client.PrimaryNumber
        : isEnquirerWasBusiness
            ? delivery.CremationOrder.Business.Phone
            : delivery.CremationOrder.Client.PrimaryNumber) || null;

    const mobile = (!isCremationOrder
        ? isEnquiryByBusiness
            ? delivery.Enquiry.Business.Mobile
            : delivery.Enquiry.Client.SecondaryNumber
        : isEnquirerWasBusiness
            ? delivery.CremationOrder.Business.Mobile
            : delivery.CremationOrder.Client.SecondaryNumber) || null;

    let linkToParent = null;
    let linkText = null;

    if (delivery && delivery.CremationOrder && delivery.CremationOrder.ID && delivery.CremationOrder.LegacyKey) {
        linkToParent = PAGE_CREMATIONS + `${delivery.CremationOrder.LegacyKey}/${delivery.CremationOrder.ID}`;
        linkText = delivery.CremationOrder.LegacyKey;
    } else if (delivery && delivery.Enquiry && delivery.Enquiry.ID && delivery.Enquiry.LegacyKey) {
        linkToParent = PAGE_ENQUIRIES + `${delivery.Enquiry.ID}`;
        linkText = delivery.Enquiry.LegacyKey;
    }

    return (
        <div className={'runsheet'}>
            <Table
                thead={
                    <thead>
                    <HeaderRow pad>
                        <Cell colSpan={2}>
                            <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                                <div>
                                    <span className="runsheet-header">
                                        <DriverDeliveryIcon /> #{countA} Delivery: {deceasedName}
                                    </span>
                                </div>
                                <p className="header-record">
                                    {linkToParent && (
                                        <Button variant="link-white" href={linkToParent}>
                                            {linkText}
                                        </Button>
                                    )}
                                </p>
                            </Inline>
                        </Cell>
                    </HeaderRow>
                    </thead>
                }>
                <Row pad>
                    <Cell>
                        <h5>Delivery Information</h5>
                        <p>
                            <span className="info">Expected time:&nbsp;</span>
                            {deliveryDateTime}
                        </p>
                        <p>
                            <span className="info">Containment:&nbsp;</span>
                            {containment}
                        </p>
                        <p>
                            <span className="info">Collected for:&nbsp;</span>
                            {ashesCollectedBy}
                        </p>
                        <p>
                            <span className="info">Comments:&nbsp;</span>
                            <span className="comments">{comment}</span>
                        </p>
                    </Cell>
                    <Cell>
                        <h5>Delivery Location</h5>
                        <p>
                            <span className="info">Address:&nbsp;</span>
                            {addrString}
                        </p>
                        <p>
                            <span className="info">Recipient:&nbsp;</span>
                            {name}
                        </p>
                        <p>
                            <span className="info">Phone:&nbsp;</span>
                            {mobile}{!!mobile && !!phone && ' / '}{phone}{!mobile && !phone && spacer}
                        </p>
                        <p>
                            <span className="info">Assigned Driver:&nbsp;</span>
                            {staff}
                        </p>
                    </Cell>
                </Row>
            </Table>
        </div>
    );
}
